import type { BlockDiscussion } from 'shared-types';

type LocaleData = BlockDiscussion['locales'][string];

const defaultBlockData = {
  allowAnonymousComments: false,
  format: 'html' as const
};

const translatable: LocaleData['translatable'] = {
  text: '',
  title: ''
};
const defaultLocaleData: LocaleData = { translatable };

const localePlaceholders = {
  text: '{{ locales.translatable.text }}' as const,
  title: '{{ locales.translatable.title }}' as const
};

export const defaults = {
  defaultBlockData,
  defaultLocaleData,
  localePlaceholders
};

export const blockDiscussionData: BlockDiscussion = {
  ...defaultBlockData,
  ...localePlaceholders,
  locales: new Proxy({} as BlockDiscussion['locales'], {
    get: (locales, languageVersion: string) => {
      return (locales[languageVersion] = defaultLocaleData);
    }
  })
};
